'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwLabel = require('../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _DateUtils = require('../../utils/DateUtils');

var _Days = require('./Days.scss');

var _Days2 = _interopRequireDefault(_Days);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Each Day represents a cell in the calendar. Day objects are dynamically assigned their class based on whether they
 * are the current day or the a selected.
 */
var Days = function Days(props) {
  var dateOnly = props.value ? (0, _DateUtils.extractDate)(props.value, props.isDateTime) : undefined;
  var selected = props.isDateTime ? props.value : (0, _moment2.default)(dateOnly);

  /**
   * On click we'll create a day object and pass that object back up the chain so that it can update the value in the
   * date picker.
   */
  var handleClick = function handleClick() {
    var date = props.isDateTime ? (0, _DateUtils.getDate)(props.day, props.month, props.year) : (0, _DateUtils.getUtcDate)(props.day, props.month, props.year);
    props.onChange(date);
  };

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_Days2.default.days, (0, _defineProperty3.default)({}, _Days2.default.selected, props.day === selected.date() && props.month === selected.month())),
      onClick: handleClick },
    _react2.default.createElement(
      _CwLabel2.default,
      null,
      props.day.toString()
    )
  );
};

Days.propTypes = {
  /**
   * A working instance of a Date Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_moment2.default), _propTypes2.default.instanceOf(Date)]),
  /**
   * The actual day to be displayed. Should be a single number as a string.
   */
  day: _propTypes2.default.number,
  /**
   * The current working month, should be a number as a string
   */
  month: _propTypes2.default.number,
  /**
   * The current working year, should be a number as a string
   */
  year: _propTypes2.default.number,
  /**
   * A function that should update the value in the text field when one has been selected from the Calendar.
   */
  onChange: _propTypes2.default.func
};

exports.default = Days;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/Days.js
// module id = 828
// module chunks = 10